export const calculation = {
  data () {
    return {
    }
  },
  methods: {
    obliczenia_sprzetu () {
      var iloscOtworow = 3
      // eslint-disable-next-line
      var countU = 0
      var countUotw = 0
      var countStandby = 0
      var countNormal = 0
      var countSpeech = 0
      var countAlarm = 0
      // eslint-disable-next-line
      var countWhoop = 0
      // eslint-disable-next-line
      var countMaxBattery = 0

      // eslint-disable-next-line
      var maxHeight = 0
      // eslint-disable-next-line
      var wysokoscSamychProduktow = 0
      var wagaBosch = 0
      var cenaBosch = 0
      var wagaPulsar = 0
      var cenaPulsar = 0
      var wagaPulsarPoza = 0
      var cenaPulsarPoza = 0
      var wagaStale = 0
      var cenaStale = 0
      var wagaPulsarWyroby = 0
      var cenaPulsarWyroby = 0
      var mocCieplna = 0
      var maxPobor = 0
      var liczbaSprzetu = 0
      var boschWszafie = []
      var pulsarWszafie = []
      var pulsarPozaSzafa = []
      var wzmacniaczRezerwowy = []
      var liczbaLini = 0

      var PARAM_SPEECH = this.config.parameters.time_speech
      var PARAM_ALARM = this.config.parameters.time_alarm
      var PARAM_SAFETY = this.config.parameters.battery_safety
      // var PARAM_SLOW = this.config.parameters.slow_whoop
      // var PARAM_ANNO = this.config.parameters.anno
      var PARAM_STANDBY = this.inputs.czas_podtrzymania.value
      var PARAM_NORMAL = this.inputs.czas_podtrzymania.value
      var PROCENT_CENOWY = Number(this.config.cennik.procent / 100)

      var iloscWzmacniaczy = 0
      var iloscWzmacniaczyRezerwowych = 0
      var iloscKontrolerow = 0
      var iloscRouterow = 0
      var dodatkowaWartosc20kHz = 50
      var sumaStandbyDoMocy = 0
      var sumaNormalDoMocy = 0

      var iloscWariant1 = 0
      var iloscWariant1Rozszerzenia = 0
      var iloscWariant2 = 0
      var iloscWariant2Rozszerzenia = 0
      var iloscWariant3 = 0
      var iloscWariant3Rozszerzenia = 0
      var iloscWariant4 = 0
      var iloscWariant4Rozszerzenia = 0
      // var iloscWariant5 = 0
      // var iloscWariant5Rozszerzenia = 0

      var iloscMikrofonow = 0
      var iloscRozszerzen = 0
      var iloscObudowaPlytki = 0
      var iloscKolek = 0

      var panelSygnalizacyjny = true

      // =================================================================== wzmacniacz
      iloscWzmacniaczy = this.inputs.wzmacniacz.value
      if (iloscWzmacniaczy > 0) {
        countU += iloscWzmacniaczy * Number(this.ListaAkcesoria['wzmacniacz'].attributes.wysokosc)
        countUotw += iloscWzmacniaczy * Number(this.ListaAkcesoria['wzmacniacz'].attributes.otwory)

        countStandby += iloscWzmacniaczy * (Number(this.ListaAkcesoria['wzmacniacz'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        countNormal += iloscWzmacniaczy * (Number(this.ListaAkcesoria['wzmacniacz'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)
        countSpeech += iloscWzmacniaczy * (Number(this.ListaAkcesoria['wzmacniacz'].current.speech) * (Number(PARAM_SPEECH)) / 60000)
        countAlarm += iloscWzmacniaczy * (Number(this.ListaAkcesoria['wzmacniacz'].current.alarm) * (Number(PARAM_ALARM)) / 60000)
        countWhoop += iloscWzmacniaczy * Number(this.ListaAkcesoria['wzmacniacz'].current.whoop)
        countMaxBattery += iloscWzmacniaczy * Number(this.ListaAkcesoria['wzmacniacz'].current.whoop)

        maxHeight += iloscWzmacniaczy * Number(this.ListaAkcesoria['wzmacniacz'].attributes.wysokosc)
        wysokoscSamychProduktow += iloscWzmacniaczy * Number(this.ListaAkcesoria['wzmacniacz'].attributes.wysokosc)

        wagaBosch += iloscWzmacniaczy * Number(this.ListaAkcesoria['wzmacniacz'].attributes.waga)
        cenaBosch += iloscWzmacniaczy * Number(this.ListaAkcesoria['wzmacniacz'].attributes.cena)

        mocCieplna += (Number(iloscWzmacniaczy) * 250)
        maxPobor += (Number(iloscWzmacniaczy) * (3.25 / 0.85))

        this.ListaAkcesoria['wzmacniacz'].sztuk = iloscWzmacniaczy
        boschWszafie.push(this.ListaAkcesoria['wzmacniacz'])
        liczbaSprzetu++
      }
      // =================================================================== wzmacniacz rezerwowy
      iloscWzmacniaczyRezerwowych = this.inputs.wzmacniacz_rezerwowy.value
      if (iloscWzmacniaczyRezerwowych > 0) {
        countU += iloscWzmacniaczyRezerwowych * Number(this.ListaAkcesoria['wzmacniacz'].attributes.wysokosc)
        countUotw += iloscWzmacniaczyRezerwowych * Number(this.ListaAkcesoria['wzmacniacz'].attributes.otwory)

        countStandby += iloscWzmacniaczyRezerwowych * (Number(this.ListaAkcesoria['wzmacniacz'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)

        maxHeight += iloscWzmacniaczyRezerwowych * Number(this.ListaAkcesoria['wzmacniacz'].attributes.wysokosc)
        wysokoscSamychProduktow += iloscWzmacniaczyRezerwowych * Number(this.ListaAkcesoria['wzmacniacz'].attributes.wysokosc)

        wagaBosch += iloscWzmacniaczyRezerwowych * Number(this.ListaAkcesoria['wzmacniacz'].attributes.waga)
        cenaBosch += iloscWzmacniaczyRezerwowych * Number(this.ListaAkcesoria['wzmacniacz'].attributes.cena)

        wzmacniaczRezerwowy.push({
          grupa: this.ListaAkcesoria['wzmacniacz'].grupa,
          gen_code: this.ListaAkcesoria['wzmacniacz'].gen_code,
          typ: this.ListaAkcesoria['wzmacniacz'].typ,
          kod: this.ListaAkcesoria['wzmacniacz'].kod,
          klasa: this.ListaAkcesoria['wzmacniacz'].klasa + '_rez',
          nazwa: this.ListaAkcesoria['wzmacniacz'].nazwa,
          current: {
            standby: this.ListaAkcesoria['wzmacniacz'].current.standby,
            normal: this.ListaAkcesoria['wzmacniacz'].current.normal,
            speech: this.ListaAkcesoria['wzmacniacz'].current.speech,
            alarm: this.ListaAkcesoria['wzmacniacz'].current.alarm,
            whoop: this.ListaAkcesoria['wzmacniacz'].current.whoop
          },
          attributes: {
            wysokosc: this.ListaAkcesoria['wzmacniacz'].attributes.wysokosc,
            otwory: this.ListaAkcesoria['wzmacniacz'].attributes.otwory,
            waga: this.ListaAkcesoria['wzmacniacz'].attributes.waga,
            cena: this.ListaAkcesoria['wzmacniacz'].attributes.cena
          },
          sztuk: iloscWzmacniaczyRezerwowych
        })

        boschWszafie.push(wzmacniaczRezerwowy[0])
        liczbaSprzetu++
      }
      // =================================================================== kontrolery
      iloscKontrolerow = this.inputs.kontroler.value
      if (iloscKontrolerow > 0) {
        if (this.inputs.sygnal_pilota_cb.value) {
          dodatkowaWartosc20kHz = 50
        } else {
          dodatkowaWartosc20kHz = 0
        }

        countU += Number(this.ListaAkcesoria['kontroler'].attributes.wysokosc)
        countUotw += Number(this.ListaAkcesoria['kontroler'].attributes.otwory)

        countStandby += ((Number(this.ListaAkcesoria['kontroler'].current.standby) + dodatkowaWartosc20kHz) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        countNormal += ((Number(this.ListaAkcesoria['kontroler'].current.normal) + dodatkowaWartosc20kHz) * ((Number(PARAM_NORMAL) * 60)) / 60000)
        countSpeech += ((Number(this.ListaAkcesoria['kontroler'].current.speech) + dodatkowaWartosc20kHz) * (Number(PARAM_SPEECH)) / 60000)
        countAlarm += ((Number(this.ListaAkcesoria['kontroler'].current.alarm) + dodatkowaWartosc20kHz) * (Number(PARAM_ALARM)) / 60000)

        sumaStandbyDoMocy += ((Number(this.ListaAkcesoria['kontroler'].current.standby) + dodatkowaWartosc20kHz) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        sumaNormalDoMocy += ((Number(this.ListaAkcesoria['kontroler'].current.normal) + dodatkowaWartosc20kHz) * ((Number(PARAM_NORMAL) * 60)) / 60000)

        mocCieplna += (Number(iloscKontrolerow) * 60)
        liczbaLini += (Number(iloscKontrolerow) * 12)

        maxHeight += iloscKontrolerow * Number(this.ListaAkcesoria['kontroler'].attributes.wysokosc)
        wysokoscSamychProduktow += iloscKontrolerow * Number(this.ListaAkcesoria['kontroler'].attributes.wysokosc)

        wagaBosch += iloscKontrolerow * Number(this.ListaAkcesoria['kontroler'].attributes.waga)
        cenaBosch += iloscKontrolerow * Number(this.ListaAkcesoria['kontroler'].attributes.cena)

        this.ListaAkcesoria['kontroler'].sztuk = iloscKontrolerow
        boschWszafie.push(this.ListaAkcesoria['kontroler'])
        liczbaSprzetu++
      }
      // =================================================================== router
      iloscRouterow = this.inputs.router.value
      if (iloscRouterow > 0) {
        if (this.inputs.sygnal_pilota_cb.value) {
          dodatkowaWartosc20kHz = (50 * 2)
        } else {
          dodatkowaWartosc20kHz = 0
        }
        countU += iloscRouterow * Number(this.ListaAkcesoria['router'].attributes.wysokosc)
        countUotw += iloscRouterow * Number(this.ListaAkcesoria['router'].attributes.otwory)
        countStandby += iloscRouterow * ((Number(this.ListaAkcesoria['router'].current.standby) + dodatkowaWartosc20kHz) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        countNormal += iloscRouterow * ((Number(this.ListaAkcesoria['router'].current.normal) + dodatkowaWartosc20kHz) * ((Number(PARAM_NORMAL) * 60)) / 60000)
        countSpeech += iloscRouterow * ((Number(this.ListaAkcesoria['router'].current.speech) + dodatkowaWartosc20kHz) * (Number(PARAM_SPEECH)) / 60000)
        countAlarm += iloscRouterow * ((Number(this.ListaAkcesoria['router'].current.alarm) + dodatkowaWartosc20kHz) * (Number(PARAM_ALARM)) / 60000)
        // countWhoop += iloscRouterow * Number(this.ListaAkcesoria['router'].current.whoop);

        sumaStandbyDoMocy += iloscRouterow * ((Number(this.ListaAkcesoria['router'].current.standby) + dodatkowaWartosc20kHz) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        sumaNormalDoMocy += iloscRouterow * ((Number(this.ListaAkcesoria['router'].current.normal) + dodatkowaWartosc20kHz) * ((Number(PARAM_NORMAL) * 60)) / 60000)

        mocCieplna += (Number(iloscRouterow) * 30)
        liczbaLini += (Number(iloscRouterow) * 24)

        maxHeight += iloscRouterow * Number(this.ListaAkcesoria['router'].attributes.wysokosc)
        wysokoscSamychProduktow += iloscRouterow * Number(this.ListaAkcesoria['router'].attributes.wysokosc)

        wagaBosch += iloscRouterow * Number(this.ListaAkcesoria['router'].attributes.waga)
        cenaBosch += iloscRouterow * Number(this.ListaAkcesoria['router'].attributes.cena)

        this.ListaAkcesoria['router'].sztuk = iloscRouterow
        boschWszafie.push(this.ListaAkcesoria['router'])
        liczbaSprzetu++
      }
      // =================================================================== mikrofon w szafie
      iloscWariant1 = this.inputs.wariant1.value
      if (iloscWariant1 > 0) {
        iloscMikrofonow += Number(iloscWariant1)
        countU += iloscWariant1 * Number(this.ListaAkcesoria['mikrofon'].attributes.wysokosc)
        countUotw += iloscWariant1 * Number(this.ListaAkcesoria['mikrofon'].attributes.otwory)
        countStandby += iloscWariant1 * (Number(this.ListaAkcesoria['mikrofon'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        countNormal += iloscWariant1 * (Number(this.ListaAkcesoria['mikrofon'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)
        countSpeech += iloscWariant1 * (Number(this.ListaAkcesoria['mikrofon'].current.speech) * (Number(PARAM_SPEECH)) / 60000)
        countAlarm += iloscWariant1 * (Number(this.ListaAkcesoria['mikrofon'].current.alarm) * (Number(PARAM_ALARM)) / 60000)
        // countWhoop += iloscWariant1 * Number(this.ListaAkcesoria['mikrofon'].current.whoop)

        sumaStandbyDoMocy += iloscWariant1 * (Number(this.ListaAkcesoria['mikrofon'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        sumaNormalDoMocy += iloscWariant1 * (Number(this.ListaAkcesoria['mikrofon'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)

        maxHeight += iloscWariant1 * Number(this.ListaAkcesoria['mikrofon'].attributes.wysokosc)
        wysokoscSamychProduktow += iloscWariant1 * Number(this.ListaAkcesoria['mikrofon'].attributes.wysokosc)

        wagaBosch += iloscWariant1 * Number(this.ListaAkcesoria['mikrofon'].attributes.waga)
        cenaBosch += iloscWariant1 * Number(this.ListaAkcesoria['mikrofon'].attributes.cena)

        iloscWariant1Rozszerzenia = this.inputs.wariant1_rozszerzenia.value
        if (iloscWariant1Rozszerzenia > 0) {
          countStandby += iloscWariant1Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
          countNormal += iloscWariant1Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)
          countSpeech += iloscWariant1Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.speech) * (Number(PARAM_SPEECH)) / 60000)
          countAlarm += iloscWariant1Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.alarm) * (Number(PARAM_ALARM)) / 60000)

          sumaStandbyDoMocy += iloscWariant1Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
          sumaNormalDoMocy += iloscWariant1Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)

          wagaBosch += iloscWariant1Rozszerzenia * Number(this.ListaAkcesoria['rozszerzenie'].attributes.waga)
          cenaBosch += iloscWariant1Rozszerzenia * Number(this.ListaAkcesoria['rozszerzenie'].attributes.cena)
          iloscRozszerzen += Number(iloscWariant1Rozszerzenia)
        }
        liczbaSprzetu++
      }
      // =================================================================== mikrofon poza szafą
      iloscWariant2 = this.inputs.wariant2.value
      if (iloscWariant2 > 0) {
        iloscMikrofonow += Number(iloscWariant2)
        countStandby += iloscWariant2 * (Number(this.ListaAkcesoria['mikrofon'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        countNormal += iloscWariant2 * (Number(this.ListaAkcesoria['mikrofon'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)
        countSpeech += iloscWariant2 * (Number(this.ListaAkcesoria['mikrofon'].current.speech) * (Number(PARAM_SPEECH)) / 60000)
        countAlarm += iloscWariant2 * (Number(this.ListaAkcesoria['mikrofon'].current.alarm) * (Number(PARAM_ALARM)) / 60000)
        // countWhoop += iloscWariant1 * Number(this.ListaAkcesoria['mikrofon'].current.whoop)

        sumaStandbyDoMocy += iloscWariant2 * (Number(this.ListaAkcesoria['mikrofon'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        sumaNormalDoMocy += iloscWariant2 * (Number(this.ListaAkcesoria['mikrofon'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)

        cenaBosch += iloscWariant2 * Number(this.ListaAkcesoria['mikrofon'].attributes.cena)

        iloscWariant2Rozszerzenia = this.inputs.wariant2_rozszerzenia.value
        if (iloscWariant2Rozszerzenia > 0) {
          countStandby += iloscWariant2Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
          countNormal += iloscWariant2Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)
          countSpeech += iloscWariant2Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.speech) * (Number(PARAM_SPEECH)) / 60000)
          countAlarm += iloscWariant2Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.alarm) * (Number(PARAM_ALARM)) / 60000)

          sumaStandbyDoMocy += iloscWariant2Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
          sumaNormalDoMocy += iloscWariant2Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)

          cenaBosch += iloscWariant2Rozszerzenia * Number(this.ListaAkcesoria['rozszerzenie'].attributes.cena)
          iloscRozszerzen += Number(iloscWariant2Rozszerzenia)
        }
        liczbaSprzetu++
      }
      // =================================================================== mikrofon do 80
      iloscWariant3 = this.inputs.wariant3.value
      if (iloscWariant3 > 0) {
        iloscMikrofonow += Number(iloscWariant3)
        countStandby += iloscWariant3 * (Number(this.ListaAkcesoria['mikrofon'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        countNormal += iloscWariant3 * (Number(this.ListaAkcesoria['mikrofon'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)
        countSpeech += iloscWariant3 * (Number(this.ListaAkcesoria['mikrofon'].current.speech) * (Number(PARAM_SPEECH)) / 60000)
        countAlarm += iloscWariant3 * (Number(this.ListaAkcesoria['mikrofon'].current.alarm) * (Number(PARAM_ALARM)) / 60000)
        // countWhoop += iloscWariant1 * Number(this.ListaAkcesoria['mikrofon'].current.whoop)

        sumaStandbyDoMocy += iloscWariant3 * (Number(this.ListaAkcesoria['mikrofon'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        sumaNormalDoMocy += iloscWariant3 * (Number(this.ListaAkcesoria['mikrofon'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)

        cenaBosch += iloscWariant3 * Number(this.ListaAkcesoria['mikrofon'].attributes.cena)
        cenaPulsarPoza += iloscWariant3 * Number(this.ListaAkcesoria['obudowa_mikrofonu'].attributes.cena)
        wagaPulsarPoza += iloscWariant3 * Number(this.ListaAkcesoria['obudowa_mikrofonu'].attributes.waga)

        this.ListaAkcesoria['obudowa_mikrofonu'].sztuk = iloscWariant3
        pulsarPozaSzafa.push(this.ListaAkcesoria['obudowa_mikrofonu'])

        iloscWariant3Rozszerzenia = this.inputs.wariant3_rozszerzenia.value
        if (iloscWariant3Rozszerzenia > 0) {
          countStandby += iloscWariant3Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
          countNormal += iloscWariant3Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)
          countSpeech += iloscWariant3Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.speech) * (Number(PARAM_SPEECH)) / 60000)
          countAlarm += iloscWariant3Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.alarm) * (Number(PARAM_ALARM)) / 60000)

          sumaStandbyDoMocy += iloscWariant3Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
          sumaNormalDoMocy += iloscWariant3Rozszerzenia * (Number(this.ListaAkcesoria['rozszerzenie'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)

          cenaBosch += iloscWariant3Rozszerzenia * Number(this.ListaAkcesoria['rozszerzenie'].attributes.cena)
          iloscRozszerzen += Number(iloscWariant3Rozszerzenia)
        }
        liczbaSprzetu++
      }
      // =================================================================== mikrofon od 80
      iloscWariant4 = this.inputs.wariant4.value
      if (iloscWariant4 > 0) {
        iloscMikrofonow += Number(iloscWariant4)
        cenaBosch += iloscWariant4 * Number(this.ListaAkcesoria['mikrofon'].attributes.cena)
        cenaPulsarPoza += iloscWariant4 * Number(this.ListaAkcesoria['obudowa_zasilacza'].attributes.cena)
        wagaPulsarPoza += iloscWariant4 * Number(this.ListaAkcesoria['obudowa_zasilacza'].attributes.waga)

        this.ListaAkcesoria['obudowa_zasilacza'].sztuk = iloscWariant4
        pulsarPozaSzafa.push(this.ListaAkcesoria['obudowa_zasilacza'])

        iloscWariant4Rozszerzenia = this.inputs.wariant4_rozszerzenia.value
        if (iloscWariant4Rozszerzenia > 0) {
          cenaBosch += iloscWariant3Rozszerzenia * Number(this.ListaAkcesoria['rozszerzenie'].attributes.cena)
          iloscRozszerzen += Number(iloscWariant3Rozszerzenia)
        }
        liczbaSprzetu++
      }
      // =================================================================== obudowa końca lini
      iloscObudowaPlytki = this.inputs.obudowa_plytki.value
      if (iloscObudowaPlytki > 0) {
        cenaPulsarPoza += Number(this.inputs.obudowa_plytki.value) * Number(this.ListaAkcesoria['obudowa_plytki'].attributes.cena)
        wagaPulsarPoza += Number(this.inputs.obudowa_plytki.value) * Number(this.ListaAkcesoria['obudowa_plytki'].attributes.waga)
        // + (Number(this.ListaAkcesoria['obudowa_plytki'].attributes.cena) * PROCENT_CENOWY))
        this.ListaAkcesoria['obudowa_plytki'].sztuk = iloscObudowaPlytki
        pulsarPozaSzafa.push(this.ListaAkcesoria['obudowa_plytki'])
        liczbaSprzetu++
      }
      // =================================================================== zestaw kółek
      iloscKolek = this.inputs.kolka.value
      var cenaZestawuKolek = 0
      if (iloscKolek > 0) {
        cenaZestawuKolek = Number(this.ListaAkcesoria['kolka'].attributes.cena)
        // cenaPulsarPoza += iloscKolek * Number(this.ListaAkcesoria['kolka'].attributes.cena)
        this.ListaAkcesoria['kolka'].sztuk = iloscKolek
        pulsarPozaSzafa.push(this.ListaAkcesoria['kolka'])
        liczbaSprzetu++
      }
      // =========================================================================================
      if (iloscMikrofonow > 0) {
        this.ListaAkcesoria['mikrofon'].sztuk = iloscMikrofonow
        boschWszafie.push(this.ListaAkcesoria['mikrofon'])
        // liczbaSprzetu++
      }
      // =========================================================================================
      if (iloscRozszerzen > 0) {
        this.ListaAkcesoria['rozszerzenie'].sztuk = iloscRozszerzen
        boschWszafie.push(this.ListaAkcesoria['rozszerzenie'])
        // liczbaSprzetu++
      }
      // =========================================================================================
      this.ListaAkcesoria['sygnalizator'].sztuk = 0
      if (panelSygnalizacyjny) {
        // countU += Number(this.ListaAkcesoria['sygnalizator'].attributes.wysokosc)
        countStandby += (Number(this.ListaAkcesoria['sygnalizator'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        countNormal += (Number(this.ListaAkcesoria['sygnalizator'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)
        countSpeech += (Number(this.ListaAkcesoria['sygnalizator'].current.speech) * (Number(PARAM_SPEECH)) / 60000)
        countAlarm += (Number(this.ListaAkcesoria['sygnalizator'].current.alarm) * (Number(PARAM_ALARM)) / 60000)

        sumaStandbyDoMocy += (Number(this.ListaAkcesoria['sygnalizator'].current.standby) * ((Number(PARAM_STANDBY) * 60)) / 60000)
        sumaNormalDoMocy += (Number(this.ListaAkcesoria['sygnalizator'].current.normal) * ((Number(PARAM_NORMAL) * 60)) / 60000)

        wagaPulsar += Number(this.ListaAkcesoria['sygnalizator'].attributes.waga)
        cenaPulsar += Number(this.ListaAkcesoria['sygnalizator'].attributes.cena)

        this.ListaAkcesoria['sygnalizator'].sztuk = 1
        pulsarWszafie.push(this.ListaAkcesoria['sygnalizator'])
      }
      // =========================================================================================
      var dodatkowaWartoscZasilacza = 0
      if (liczbaSprzetu > 0) {
        dodatkowaWartoscZasilacza = 300
        if (iloscWzmacniaczy > 0) {
          if (iloscWzmacniaczy < 6) {
            countStandby += (dodatkowaWartoscZasilacza * ((Number(PARAM_STANDBY) * 60)) / 60000)
            countNormal += (dodatkowaWartoscZasilacza * ((Number(PARAM_NORMAL) * 60)) / 60000)

            sumaStandbyDoMocy += (dodatkowaWartoscZasilacza * ((Number(PARAM_STANDBY) * 60)) / 60000)
            sumaNormalDoMocy += (dodatkowaWartoscZasilacza * ((Number(PARAM_NORMAL) * 60)) / 60000)
          } else {
            dodatkowaWartoscZasilacza = 500
            countStandby += (dodatkowaWartoscZasilacza * ((Number(PARAM_STANDBY) * 60)) / 60000)
            countNormal += (dodatkowaWartoscZasilacza * ((Number(PARAM_NORMAL) * 60)) / 60000)

            sumaStandbyDoMocy += (dodatkowaWartoscZasilacza * ((Number(PARAM_STANDBY) * 60)) / 60000)
            sumaNormalDoMocy += (dodatkowaWartoscZasilacza * ((Number(PARAM_NORMAL) * 60)) / 60000)
          }
        } else {
          countStandby += (dodatkowaWartoscZasilacza * ((Number(PARAM_STANDBY) * 60)) / 60000)
          countNormal += (dodatkowaWartoscZasilacza * ((Number(PARAM_NORMAL) * 60)) / 60000)
          countSpeech += (dodatkowaWartoscZasilacza * (Number(PARAM_SPEECH)) / 60000)
          countAlarm += (dodatkowaWartoscZasilacza * (Number(PARAM_ALARM)) / 60000)

          sumaStandbyDoMocy += (dodatkowaWartoscZasilacza * ((Number(PARAM_STANDBY) * 60)) / 60000)
          sumaNormalDoMocy += (dodatkowaWartoscZasilacza * ((Number(PARAM_NORMAL) * 60)) / 60000)
        }
      }
      // =========================================================================================

      var EOL_AMPLIFIER = 0
      var EOL_STANDBY = 0
      var EOL_NORMAL = 0
      var EOL_SPEECH = 0
      var EOL_ALARM = 0
      var EOL_TOTAL_STANDBY = 0
      var EOL_TOTAL_NORMAL = 0
      var EOL_TOTAL_SPEECH = 0
      var EOL_TOTAL_ALARM = 0
      // eslint-disable-next-line
      var EOL_STANDBY_TOTAL = 0
      // eslint-disable-next-line
      var EOL_NORMAL_TOTAL = 0

      var LOUDSPEAKER = iloscWzmacniaczy * 1000
      var LOUDSPEAKER_STANDBY = 0
      var LOUDSPEAKER_NORMAL = 0
      var LOUDSPEAKER_SPEECH = 0
      var LOUDSPEAKER_ALARM = 0
      var LOUDSPEAKER_TOTAL_STANDBY = 0
      var LOUDSPEAKER_TOTAL_NORMAL = 0
      var LOUDSPEAKER_TOTAL_SPEECH = 0
      var LOUDSPEAKER_TOTAL_ALARM = 0
      // eslint-disable-next-line
      var LOUDSPEAKER_STANDBY_TOTAL = 0
      // eslint-disable-next-line
      var LOUDSPEAKER_NORMAL_TOTAL = 0

      var SUMA_CURRENT_STANDY = 0
      var SUMA_CURRENT_NORMAL = 0

      var NEEDED_CURRENT_STANDY = 0
      var NEEDED_CURRENT_NORMAL = 0

      if (this.inputs.sygnal_pilota_cb.value) {
        EOL_AMPLIFIER = this.inputs.sygnal_pilota.value
      }

      EOL_STANDBY = (EOL_AMPLIFIER / (100 * 100) * (8 * 8) / 0.8) / 24 * 1000
      EOL_NORMAL = (EOL_AMPLIFIER / (100 * 100) * (8 * 8) / 0.8) / 24 * 1000

      EOL_TOTAL_STANDBY = ((Number(PARAM_STANDBY) * 60) * EOL_STANDBY) / 60000
      EOL_TOTAL_NORMAL = ((Number(PARAM_NORMAL) * 60) * EOL_NORMAL) / 60000
      EOL_TOTAL_SPEECH = (Number(PARAM_SPEECH) * EOL_SPEECH) / 60000
      EOL_TOTAL_ALARM = (Number(PARAM_ALARM) * EOL_ALARM) / 60000
      EOL_STANDBY_TOTAL = EOL_TOTAL_STANDBY + EOL_TOTAL_SPEECH + EOL_TOTAL_ALARM
      EOL_NORMAL_TOTAL = EOL_TOTAL_NORMAL + EOL_TOTAL_SPEECH + EOL_TOTAL_ALARM

      countStandby += EOL_TOTAL_STANDBY
      countNormal += EOL_TOTAL_NORMAL
      countSpeech += EOL_TOTAL_SPEECH
      countAlarm += EOL_TOTAL_ALARM

      LOUDSPEAKER = this.inputs.moc_glosnikow.value
      LOUDSPEAKER_SPEECH = (LOUDSPEAKER / (100 * 100) * (32 * 32) / 0.65) / 24 * 1000
      LOUDSPEAKER_ALARM = (LOUDSPEAKER / (100 * 100) * (70.71 * 70.71) / 0.65) / 24 * 1000

      LOUDSPEAKER_TOTAL_STANDBY = ((Number(PARAM_STANDBY) * 60) * LOUDSPEAKER_STANDBY) / 60000
      LOUDSPEAKER_TOTAL_NORMAL = ((Number(PARAM_NORMAL) * 60) * LOUDSPEAKER_NORMAL) / 60000
      LOUDSPEAKER_TOTAL_SPEECH = (Number(PARAM_SPEECH) * LOUDSPEAKER_SPEECH) / 60000
      LOUDSPEAKER_TOTAL_ALARM = (Number(PARAM_ALARM) * LOUDSPEAKER_ALARM) / 60000

      LOUDSPEAKER_STANDBY_TOTAL = LOUDSPEAKER_TOTAL_STANDBY + LOUDSPEAKER_TOTAL_SPEECH + LOUDSPEAKER_TOTAL_ALARM
      LOUDSPEAKER_NORMAL_TOTAL = LOUDSPEAKER_TOTAL_NORMAL + LOUDSPEAKER_TOTAL_SPEECH + LOUDSPEAKER_TOTAL_ALARM

      countStandby += LOUDSPEAKER_TOTAL_STANDBY
      countNormal += LOUDSPEAKER_TOTAL_NORMAL
      countSpeech += LOUDSPEAKER_TOTAL_SPEECH
      countAlarm += LOUDSPEAKER_TOTAL_ALARM

      var sieciowanieSystemu = (this.inputs.sieciowanie_systemu.value === 'nie') ? 0 : 625

      countStandby += (Number(sieciowanieSystemu) * ((Number(PARAM_STANDBY) * 60)) / 60000)
      countNormal += (Number(sieciowanieSystemu) * ((Number(PARAM_NORMAL) * 60)) / 60000)
      countSpeech += (Number(sieciowanieSystemu) * (Number(PARAM_SPEECH)) / 60000)
      countAlarm += (Number(sieciowanieSystemu) * (Number(PARAM_ALARM)) / 60000)

      SUMA_CURRENT_STANDY = (countStandby + countSpeech + countAlarm)
      SUMA_CURRENT_NORMAL = (countNormal + countSpeech + countAlarm)

      NEEDED_CURRENT_STANDY = (Number(PARAM_SAFETY) * SUMA_CURRENT_STANDY) / 100 + SUMA_CURRENT_STANDY
      NEEDED_CURRENT_NORMAL = (Number(PARAM_SAFETY) * SUMA_CURRENT_NORMAL) / 100 + SUMA_CURRENT_NORMAL

      var pojAkumulatoraLiczona = (this.inputs.tryb_poboru_mocy.value === 'normal') ? NEEDED_CURRENT_NORMAL : NEEDED_CURRENT_STANDY

      // console.log('============================')
      // console.log('countStandby: ' + countStandby)
      // console.log('countNormal: ' + countNormal)
      // console.log('countSpeech: ' + countSpeech)
      // console.log('countAlarm: ' + countAlarm)
      // console.log('countWhoop: ' + countWhoop)
      // console.log('NEEDED_CURRENT_STANDY: ' + NEEDED_CURRENT_STANDY)
      // console.log('NEEDED_CURRENT_NORMAL: ' + NEEDED_CURRENT_NORMAL)
      // console.log('countMaxBattery: ' + ((countMaxBattery + countAlarm) / 24))
      // console.log('============================')
      // ===========================================================================================
      // ===========================================================================================
      // ===========================================================================================

      var mocZasilacza = 0
      var napiecie = 28.6
      var WYSOKOSC_SZAFY = Number(this.outputs.szafa.attributes.wysokosc)
      var GLEBOKOSC_SZAFY = Number(this.outputs.szafa.attributes.glebokosc)
      var WYSOKOSC_SZAFY_OTW = Number(this.outputs.szafa.attributes.wysokosc) * iloscOtworow
      var STALE_W_SZAFIE = []

      // console.log('yyy: ', this.inputs.glebokosc_szafy.value)
      // TUTAJ JESLI WYBIERAM WŁASNY AKUMULATOR
      var aBattries = []
      if (this.outputs.akumulator_user.value) {
        STALE_W_SZAFIE['akumulator'] = this.outputs.akumulator
      } else {
        if (this.inputs.glebokosc_szafy.active) {
          aBattries = this.search_akumulator_depth(pojAkumulatoraLiczona, this.inputs.glebokosc_szafy.value) // , this.inputs.glebokosc_szafy.value)
        } else {
          aBattries = this.search_akumulator(pojAkumulatoraLiczona, this.outputs.szafa.attributes.glebokosc) // , this.inputs.glebokosc_szafy.value)
        }
        // item.nazwa = item.nazwa[this.$i18n.locale]
        this.changeValueOutputs('mozliwe_akumulatory', 'array', aBattries)
        STALE_W_SZAFIE['akumulator'] = aBattries[0]// this.selected_akumulator(aBattries, this.inputs.glebokosc_szafy.value)
        // console.log(aBattries[0])
        this.changeValueOutputs('akumulator', 'array', aBattries[0])
      }
      // console.log(STALE_W_SZAFIE['akumulator'])

      // ===========================================================================================
      // ===========================================================================================
      // ===========================================================================================

      // console.log('xxx: ', this.inputs.glebokosc_szafy.value)
      if (STALE_W_SZAFIE['akumulator'].length === 0) {
        alert('INFORMACJA\nBRAK AKUMULATORÓW DLA ZADANEJ SZAFY')
        return false
      }

      // =================================================================
      // =================================================================
      // =================================================================
      var dodatkoweU = Number(this.inputs.dodatkowe_u.value) // - 1
      var dodatkoweUotw = Number(dodatkoweU * iloscOtworow) // - 1

      var wysokoscZasilacza = this.ListaZasilacze[0].attributes.wysokosc
      var wysokosclistwaD = this.ListaListwyD[0].attributes.wysokosc
      var wysokosclistwaZ = this.ListaListwyZ[0].attributes.wysokosc
      var WYSOKOSC_STALE_W_SZAFIE = Number(wysokoscZasilacza) + Number(wysokosclistwaD) + Number(wysokosclistwaZ)
      var WYSOKOSC_STALE_W_SZAFIE_OTW = WYSOKOSC_STALE_W_SZAFIE * iloscOtworow
      var WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR = Number(STALE_W_SZAFIE['akumulator'].wysokosc)
      var WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR_OTW = WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR * iloscOtworow
      // var WYSOKOSC_AKUMULATOROW = Number(STALE_W_SZAFIE['akumulator'].wysokosc) * iloscOtworow
      // var WYSOKOSC_STALYCH = WYSOKOSC_STALE_W_SZAFIE * iloscOtworow

      var maxDodatkoweU = (50 * iloscOtworow) - (countUotw + ((WYSOKOSC_STALE_W_SZAFIE + WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR) * iloscOtworow))
      // console.log('maxDodatkoweU: ', Math.floor(maxDodatkoweU / 3))
      this.changeValueInputs('dodatkowe_u', 'max', Math.floor(maxDodatkoweU / 3))

      // eslint-disable-next-line
      // var zajmowaneMiejsce = countU + ((WYSOKOSC_STALE_W_SZAFIE + WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR)) + dodatkoweU
      var zajmowaneOtw = countUotw + ((WYSOKOSC_STALE_W_SZAFIE + WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR) * iloscOtworow) + dodatkoweUotw

      // eslint-disable-next-line
      var wolneMiejsce = WYSOKOSC_SZAFY - countU - WYSOKOSC_STALE_W_SZAFIE - WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR
      // eslint-disable-next-line
      var wolneMiejsceOtw = WYSOKOSC_SZAFY_OTW - countUotw - WYSOKOSC_STALE_W_SZAFIE_OTW - WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR_OTW

      var wysokoscSzafyU = (zajmowaneOtw / 3) - 0.1

      var matchRACK = []
      // if (this.inputs.glebokosc_szafy.active) {
      //   matchRACK = this.outputs.szafa
      // } else {
      //   matchRACK = this.search_szafy_dla_akumulatorow(wysokoscSzafyU, STALE_W_SZAFIE['akumulator'].glebokosc)
      // }
      matchRACK = this.search_szafy_dla_akumulatorow(wysokoscSzafyU, STALE_W_SZAFIE['akumulator'].glebokosc)

      // console.log('WYSOKOSC_SZAFY_OTW', WYSOKOSC_SZAFY_OTW)
      // console.log('================')
      // console.log('WYSOKOSC_STALE', WYSOKOSC_STALE_W_SZAFIE_OTW)
      // console.log('WYSOKOSC_AKUMULATOR', WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR_OTW)
      // console.log('SUMA_STAŁYCH', (WYSOKOSC_STALE_W_SZAFIE_OTW + WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR_OTW))
      // console.log('================')
      // console.log('Pozostałe miejsce po STAŁYCH', (WYSOKOSC_SZAFY_OTW - (WYSOKOSC_STALE_W_SZAFIE_OTW + WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR_OTW)))
      // console.log('================')
      // console.log('countUotw', countUotw)
      // console.log('================')
      // console.log('Pozostałe miejsce', (WYSOKOSC_SZAFY_OTW - (WYSOKOSC_STALE_W_SZAFIE_OTW + WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR_OTW) - countUotw))

      if (matchRACK[0]) {
        if (this.inputs.glebokosc_szafy.active) {
          // this.check_depth_rack(matchRACK[0].attributes.wysokosc, this.ListaSzafy)
          matchRACK = this.search_szafy_dla_akumulatorow_depth(wysokoscSzafyU, this.inputs.glebokosc_szafy.value)
          // console.log(matchRACK)
          if (matchRACK.length === 0) {
            alert('INFORMACJA\nBrak miejsca w szafie o zadanej glebokosci')
            this.changeValueInputs('glebokosc_szafy', 'active', false)
            this.changeValueOutputs('szafa_user', 'value', false)
            this.obliczenia_sprzetu()
          }
          // aBattries = this.search_akumulator_depth(pojAkumulatoraLiczona, this.inputs.glebokosc_szafy.value)
          // this.changeValueOutputs('mozliwe_akumulatory', 'array', aBattries)
          // STALE_W_SZAFIE['akumulator'] = aBattries[0]
          // this.changeValueOutputs('akumulator', 'array', aBattries[0])
          // this.changeValueOutputs('szafa', 'array', matchRACK[0])
          // this.changeValueInputs('glebokosc_szafy', 'value', this.inputs.glebokosc_szafy.value)
        } else {
          this.changeValueOutputs('szafa', 'array', matchRACK[0])
          this.changeValueInputs('glebokosc_szafy', 'value', matchRACK[0].attributes.glebokosc)
          this.check_depth_rack(matchRACK[0].attributes.wysokosc, this.ListaSzafy)
        }
      } else {
        this.changeValueInputs(this.selected_input, 'value', (this.inputs[this.selected_input].value - 1))
        alert('INFORMACJA\nBrak szafy dla zadanych elementów!')
      }

      // console.log('zzz: ', this.inputs.glebokosc_szafy.value)

      // if (!this.outputs.szafa_user.value) {
      //   if (!this.inputs.glebokosc_szafy.active) {
      //     this.wielkosc_szafy_rack(WYSOKOSC_SZAFY_OTW, zajmowaneOtw)
      //     this.changeValueInputs('glebokosc_szafy', 'value', this.outputs.szafa.attributes.glebokosc)
      //     // this.changeValueOutputs('szafa_wolne_miejsce', 'value', (Math.floor(wolneMiejsceOtw / 3) - 1))
      //   } else {
      //     if (wolneMiejsceOtw < 0) {
      //       console.log('AAA')
      //       this.changeValueInputs('glebokosc_szafy', 'active', false)
      //       this.wielkosc_szafy_rack(WYSOKOSC_SZAFY_OTW, zajmowaneOtw)
      //     } else {
      //       console.log('BBB')
      //       // this.search_depth_szafy(this.outputs.szafa.attributes.wysokosc, this.inputs.glebokosc_szafy.value, zajmowaneOtw)
      //       this.zmien_szafe_po_glebokosci(WYSOKOSC_SZAFY, this.inputs.glebokosc_szafy.value)
      //     }
      //   }
      // } else {

      // }

      if (this.outputs.szafa.attributes.wysokosc !== WYSOKOSC_SZAFY || this.outputs.szafa.attributes.glebokosc !== GLEBOKOSC_SZAFY) {
        // this.obliczenia_sprzetu()
      }

      // WYSOKOSC_SZAFY = Number(this.outputs.szafa.attributes.wysokosc) * iloscOtworow
      // wolneMiejsce = WYSOKOSC_SZAFY - countUotw - (WYSOKOSC_STALE_W_SZAFIE * iloscOtworow) - (WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR * iloscOtworow)

      // // =================================================================
      // // =================================================================
      // // =================================================================

      if (Object.keys(STALE_W_SZAFIE['akumulator']).length > 0) {
        var pradLadowaniaAkumulatora = ((Number(STALE_W_SZAFIE['akumulator'].pojemnosc) * 1.05) / 24).toFixed(2)
        var zapasPojemnosci = Number(STALE_W_SZAFIE['akumulator'].pojemnosc - pojAkumulatoraLiczona).toFixed(2)

        if (zapasPojemnosci < 0) {
          alert('INFORMACJA - NIE ODPOWIEDNI AKUMULATOR')
        }

        this.changeValueOutputs('zapas_pojemnosci', 'value', zapasPojemnosci)

        if (this.inputs.tryb_poboru_mocy.value === 'normal') {
          mocZasilacza = (((sumaNormalDoMocy / 24) * napiecie) + (pradLadowaniaAkumulatora * napiecie)).toFixed(2)
        } else {
          mocZasilacza = (((sumaStandbyDoMocy / 24) * napiecie) + (pradLadowaniaAkumulatora * napiecie)).toFixed(2)
        }
        // console.log('jaki_pobor: ' + this.inputs.tryb_poboru_mocy.value)
        // console.log('mocZasilacza', mocZasilacza)

        var deviceCurrent = []
        // eslint-disable-next-line
        var maxBattery = 0

        if ((parseInt((countStandby * 1000) / 1000) / (parseInt(PARAM_STANDBY) * 60)) * 60 > 0) {
          deviceCurrent.push((parseInt((countStandby * 1000) / 1000) / (parseInt(PARAM_STANDBY) * 60)) * 60)
        } // standby
        if ((parseInt((countNormal * 1000) / 1000) / (parseInt(PARAM_NORMAL) * 60)) * 60 > 0) {
          deviceCurrent.push((parseInt((countNormal * 1000) / 1000) / (parseInt(PARAM_NORMAL) * 60)) * 60)
        } // normal
        if ((parseInt((countSpeech * 1000) / 1000) / (parseInt(PARAM_SPEECH) * 60)) * 60 > 0) {
          deviceCurrent.push((parseInt((countSpeech * 1000) / 1000) / (parseInt(PARAM_SPEECH) * 60)) * 60)
        } // speech
        if ((parseInt((countAlarm * 1000) / 1000) / (parseInt(PARAM_ALARM) * 60)) * 60 > 0) {
          deviceCurrent.push((parseInt((countAlarm * 1000) / 1000) / (parseInt(PARAM_ALARM) * 60)) * 60)
        } // alarm

        deviceCurrent.sort(function (a, b) { return a - b })
        maxBattery = deviceCurrent[0]
      } else {
        alert('INFORMACJA - BRAK AKUMULATORÓW DLA ZADANEJ KONFIGURACJI')
      }
      // ======================================================================== ZASILACZ
      var aPowerSupply = this.search_zasilacz(Number(mocZasilacza), (Number(iloscWzmacniaczy) + Number(iloscWzmacniaczyRezerwowych)), Number(STALE_W_SZAFIE['akumulator'].ilosc))

      if (aPowerSupply.length > 0) {
        STALE_W_SZAFIE['zasilacz'] = aPowerSupply[0]
        this.changeValueOutputs('zasilacz', 'array', aPowerSupply[0])

        mocCieplna += Number(STALE_W_SZAFIE['zasilacz'].attributes.moc) * 0.15
        this.changeValueOutputs('moc_cieplna', 'value', mocCieplna)
        maxPobor += Number(STALE_W_SZAFIE['zasilacz'].attributes.pobor)
      } else {
        STALE_W_SZAFIE['zasilacz'] = []
        console.log('Brak zasilacza')
      }
      // console.log('wzm: ' + (Number(iloscWzmacniaczy) + Number(iloscWzmacniaczyRezerwowych)))
      // console.log('akum: ' + STALE_W_SZAFIE['akumulator'].ilosc)
      // console.log('zm_moc_cieplna: ' + mocCieplna)
      // console.log('zm_max_pobor: ' + maxPobor)
      // ======================================================================== LISTWA DYSTRYBUCJI
      var iloscFaz = 0
      var zabezpieczenie = 0
      var przylaczeZasilania = ''

      if (maxPobor > 15) {
        this.$store.commit('app/UPDATE_VALUE', {'name': 'disable_change_phase', 'type': 'value', 'val': true})
      } else {
        this.$store.commit('app/UPDATE_VALUE', {'name': 'disable_change_phase', 'type': 'value', 'val': false})
      }

      var mcp = this.$store.state.app.manual_change_phase.value
      // var dcp = this.$store.state.app.disable_change_phase.value

      if (maxPobor > 15 || mcp === true) {
        iloscFaz = 3
        maxPobor = this.pobor_pradu_3fazy(Number(iloscWzmacniaczy), Number(STALE_W_SZAFIE['zasilacz'].attributes.pobor))
        zabezpieczenie = this.bezpiecznik(maxPobor)
        przylaczeZasilania = this.$i18n.messages[this.$i18n.locale].message['faza3']
      } else {
        iloscFaz = 1
        zabezpieczenie = 20
        przylaczeZasilania = this.$i18n.messages[this.$i18n.locale].message['faza1']
      }
      this.changeValueOutputs('pobor_pradu', 'value', maxPobor)

      this.changeValueOutputs('przylacze_zasilania', 'value', przylaczeZasilania)
      this.changeValueOutputs('zabezpieczenia', 'value', zabezpieczenie)
      this.changeValueOutputs('ilosc_faz', 'value', iloscFaz)

      var aStripDistribution = this.search_listwyD(iloscFaz)
      STALE_W_SZAFIE['listwaD'] = (aStripDistribution.length > 0) ? aStripDistribution[0] : []
      // =========================================================================================
      if (Object.keys(STALE_W_SZAFIE['zasilacz']).length > 0) {
        var aStripProtection = this.search_listwyZ(STALE_W_SZAFIE['zasilacz'].attributes.ciag, iloscFaz)
        STALE_W_SZAFIE['listwaZ'] = (aStripProtection.length > 0) ? aStripProtection[0] : []
      } else {
        STALE_W_SZAFIE['listwaZ'] = []
      }
      // =========================================================================================
      if (Object.keys(STALE_W_SZAFIE['akumulator']).length > 0 && Object.keys(STALE_W_SZAFIE['zasilacz']).length > 0 && Object.keys(STALE_W_SZAFIE['listwaD']).length > 0 && Object.keys(STALE_W_SZAFIE['listwaZ']).length > 0) {
        WYSOKOSC_STALE_W_SZAFIE = (Number(STALE_W_SZAFIE['zasilacz'].attributes.wysokosc) + Number(STALE_W_SZAFIE['listwaD'].attributes.wysokosc) + Number(STALE_W_SZAFIE['listwaZ'].attributes.wysokosc))
        WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR = Number(STALE_W_SZAFIE['akumulator'].wysokosc)

        maxHeight += WYSOKOSC_STALE_W_SZAFIE
        maxHeight += WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR

        cenaStale = (Number(STALE_W_SZAFIE['akumulator'].cena) + Number(STALE_W_SZAFIE['zasilacz'].attributes.cena) + Number(STALE_W_SZAFIE['listwaD'].attributes.cena) + Number(STALE_W_SZAFIE['listwaZ'].attributes.cena))
        wagaStale = (Number(STALE_W_SZAFIE['akumulator'].waga) + Number(STALE_W_SZAFIE['zasilacz'].attributes.waga) + Number(STALE_W_SZAFIE['listwaD'].attributes.waga) + Number(STALE_W_SZAFIE['listwaZ'].attributes.waga))

        this.changeValueOutputs('liczba_lini', 'value', liczbaLini)
        this.changeValueOutputs('stale_w_szafie', 'array', STALE_W_SZAFIE)

        if ((Number(zajmowaneOtw) / 3) > 24) {
          this.changeValueInputs('panel_wentylacyjny', 'value', 1)
        }
        // ---------------------------------------- wentylator --------------------------
        if (this.inputs.panel_wentylacyjny.value > 0) {
          wagaPulsar += Number(this.ListaAkcesoria['wentylator'].attributes.waga)
          cenaPulsar += Number(this.ListaAkcesoria['wentylator'].attributes.cena)

          countU += Number(this.ListaAkcesoria['zaslepka'].attributes.wysokosc)
          countUotw += Number(this.ListaAkcesoria['zaslepka'].attributes.otwory)
          wagaPulsar += Number(this.ListaAkcesoria['zaslepka'].attributes.waga)
          cenaPulsar += Number(this.ListaAkcesoria['zaslepka'].attributes.cena)

          wysokoscSamychProduktow += Number(this.ListaAkcesoria['zaslepka'].attributes.wysokosc)

          this.ListaAkcesoria['wentylator'].sztuk = 1
          this.ListaAkcesoria['zaslepka'].sztuk = 1
          pulsarWszafie.push(this.ListaAkcesoria['zaslepka'])
          liczbaSprzetu++
        }
      } else {
      }

      var rabat = this.outputs.rabat.value
      var robocizna = 770 + 700 // 700 - 2021-05-05
      var transport = 100
      var cenaPalet = 2 * transport
      var cenaDodatki = robocizna + cenaPalet

      var cenaSzafy = this.outputs.szafa.attributes.cena

      var materialy = this.dodanie_materialow(STALE_W_SZAFIE['akumulator'], STALE_W_SZAFIE['zasilacz'])
      wagaPulsarWyroby = materialy.waga
      cenaPulsarWyroby = materialy.cena

      // eslint-disable-next-line
      // console.log("==== CENA ====")
      // console.log('stale - akumulator: ', Number(STALE_W_SZAFIE['akumulator'].cena))
      // console.log('stale - zasilacz: ', Number(STALE_W_SZAFIE['zasilacz'].attributes.cena))
      // console.log('stale - listwaD: ', Number(STALE_W_SZAFIE['listwaD'].attributes.cena))
      // console.log('stale - listwaZ: ', Number(STALE_W_SZAFIE['listwaZ'].attributes.cena))
      // console.log('--')
      // console.log('stale - suma: ', cenaStale)

      var cenaElementySystemu = Number(cenaBosch) + Number(cenaStale) + Number(cenaPulsar) + Number(cenaPulsarWyroby) + Number(cenaDodatki)

      // console.log('----------------')
      // console.log('cenaBosch: ', cenaBosch)
      // console.log('cenaStale: ', cenaStale)
      // console.log('cenaPulsar: ', cenaPulsar)
      // console.log('cenaPulsarWyroby: ', cenaPulsarWyroby)
      // console.log('cenaDodatki (robocizna + cenaPalet): ', cenaDodatki)

      cenaElementySystemu = Number(cenaElementySystemu).toFixed(2)
      cenaElementySystemu = Number(cenaElementySystemu) + (Number(cenaElementySystemu) * PROCENT_CENOWY)// ddodane 15%

      // console.log('--')
      // console.log('suma: ', cenaElementySystemu)
      // console.log('----------------')

      // console.log('cenaSzafy: ', cenaSzafy)
      // console.log('----------------')

      var cenaSystemu = Number(cenaElementySystemu) + Number(cenaSzafy)// do szafy już nie dodajemy 15%

      // console.log('cena systemu: ', cenaSystemu)
      // console.log('----------------')

      // eslint-disable-next-line
      var cenaSystemuBezRabatu = Number(cenaSystemu).toFixed(2)
      // var cenaSystemuBezRabatu = Math.ceil(Number(cenaSystemu) / 10 ) *10

      // console.log('cena systemu bez rabatu: ', Number(cenaSystemuBezRabatu))

      var cenaSystemuRabat = (Number(cenaSystemu) - (Number(cenaSystemu) * (Number(rabat) / 100))) // jeśli jest rabat to już od wszystkiego
      cenaSystemuRabat = Number(cenaSystemuRabat).toFixed(2)

      // console.log('cena systemu z rabatem: ', Number(cenaSystemuRabat))
      // console.log('cena Pulsar poza szafą: ', cenaPulsarPoza)

      var cenaZestawu = Number(cenaSystemuRabat) + (Number(cenaPulsarPoza) - (Number(cenaPulsarPoza) * (Number(rabat) / 100))) + Number(cenaZestawuKolek)
      cenaZestawu = Math.ceil(Number(cenaZestawu)) //  / 10) * 10

      // console.log('cenaPulsarPoza: ', cenaPulsarPoza)
      // console.log('cenaZestawuKolek: ', cenaZestawuKolek)
      // console.log('cenaZestawu: ', cenaZestawu)
      // console.log('----------------')

      var cenaZestawuBezRabatu = Number(cenaSystemu) + Number(cenaPulsarPoza) + Number(cenaZestawuKolek)

      var wagaSzafy = this.outputs.szafa.attributes.waga
      var wagaZestawu = Number(wagaSzafy) + Number(wagaBosch) + Number(wagaStale) + Number(wagaPulsar) + Number(wagaPulsarPoza) + Number(wagaPulsarWyroby)
      // console.log('wagaSzafy: ', wagaSzafy)
      // console.log('wagaBosch: ', wagaBosch)
      // console.log('wagaStale: ', wagaStale)
      // console.log('wagaPulsar: ', wagaPulsar)
      // console.log('wagaPulsarPoza: ', wagaPulsarPoza)
      // console.log('wagaPulsarWyroby: ', wagaPulsarWyroby)
      // console.log('wagaZestawu: ', wagaZestawu)
      // console.log('----------------')

      this.changeValueOutputs('waga_instalacyjna', 'value', Number(wagaZestawu).toFixed(2))
      this.changeValueOutputs('cena_netto_systemu', 'value', Math.round(Number(cenaSystemuRabat).toFixed(2)))
      this.changeValueOutputs('cena_netto_systemu_bez_rabatu', 'value', Math.round(Number(cenaSystemuBezRabatu).toFixed(2)))
      this.changeValueOutputs('cena_netto_calkowita', 'value', Math.round(Number(cenaZestawu).toFixed(2)))
      this.changeValueOutputs('cena_netto_bez_rabatu', 'value', Math.round(Number(cenaZestawuBezRabatu).toFixed(2)))

      var strNumerKonfiguracji = 'DSOP24V-'
      strNumerKonfiguracji += iloscKontrolerow
      strNumerKonfiguracji += iloscRouterow
      strNumerKonfiguracji += '-' + iloscWzmacniaczyRezerwowych
      strNumerKonfiguracji += iloscWzmacniaczy
      strNumerKonfiguracji += '-' + ((this.inputs.czas_podtrzymania.value === '6') ? '06' : this.inputs.czas_podtrzymania.value)
      strNumerKonfiguracji += '/' + this.outputs.zasilacz.gen_code
      strNumerKonfiguracji += this.outputs.akumulator.gen_code
      strNumerKonfiguracji += STALE_W_SZAFIE['listwaD'].gen_code
      strNumerKonfiguracji += STALE_W_SZAFIE['listwaZ'].gen_code
      strNumerKonfiguracji += (panelSygnalizacyjny) ? 1 : 0
      strNumerKonfiguracji += (this.inputs.panel_wentylacyjny.value > 0) ? 1 : 0
      strNumerKonfiguracji += this.outputs.szafa.gen_code
      strNumerKonfiguracji += (iloscWariant1 > 0) ? 1 : 0
      strNumerKonfiguracji += (this.inputs.kolka.value > 0) ? 1 : 0

      this.changeValueOutputs('numer_konfiguracji', 'value', strNumerKonfiguracji)
      this.changeValueOutputs('szafa_user', 'value', false)

      // Math.ceil(((Number(this.outputs.szafa.attributes.wysokosc) * 3) - pola) / 3) - 1
      // console.log('wolneMiejsce: ', wolneMiejsce)
      // console.log('wolneMiejsceOtw: ', Math.ceil(wolneMiejsceOtw / 3))

      // eslint-disable-next-line
      // console.log('WYSOKOSC_SZAFY: ', WYSOKOSC_SZAFY)
      // console.log('countU: ', countU)
      // console.log('WYSOKOSC_STALE_W_SZAFIE: ', WYSOKOSC_STALE_W_SZAFIE)
      // console.log('WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR: ', WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR)
      // console.log('---------------------------')
      // console.log(this.outputs.szafa.attributes.wysokosc)
      // eslint-disable-next-line
      // console.log('WYSOKOSC_SZAFY: ', WYSOKOSC_SZAFY_OTW)
      // console.log('countU: ', countUotw)
      // console.log('WYSOKOSC_STALE_W_SZAFIE: ', (WYSOKOSC_STALE_W_SZAFIE * iloscOtworow))
      // console.log('WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR: ', (WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR * iloscOtworow))

      WYSOKOSC_SZAFY_OTW = this.outputs.szafa.attributes.wysokosc * 3
      wolneMiejsceOtw = WYSOKOSC_SZAFY_OTW - countUotw - (WYSOKOSC_STALE_W_SZAFIE * iloscOtworow) - (WYSOKOSC_STALE_W_SZAFIE_AKUMULATOR * iloscOtworow)

      this.changeValueOutputs('szafa_wolne_miejsce', 'value', Math.round(wolneMiejsceOtw / 3))
    },
    search_szafy (iloscU) {
      var matchRack = []
      // eslint-disable-next-line
      matchRack = this.ListaSzafy.filter(item => item.attributes.wysokosc > iloscU)
      return matchRack
    },
    search_szafy_dla_akumulatorow (iloscU, glebokosc) {
      var matchRack = []
      matchRack = this.ListaSzafy.filter(item => (item.attributes.wysokosc > iloscU && glebokosc.indexOf(item.attributes.glebokosc) > -1))
      return matchRack
    },
    search_szafy_dla_akumulatorow_depth (iloscU, glebokosc) {
      var matchRack = []
      matchRack = this.ListaSzafy.filter(item => (item.attributes.wysokosc > iloscU && Number(glebokosc) === Number(item.attributes.glebokosc)))
      // console.log(matchRack)
      return matchRack
    },
    search_depth_szafy (wysokosc, glebokosc, otw) {
      var matchSzafa = []
      matchSzafa = this.ListaSzafy.filter(item => (item.attributes.wysokosc === wysokosc && item.attributes.glebokosc === glebokosc))
      this.changeValueOutputs('szafa', 'array', matchSzafa[0])
      var wolneMiejsceOtw = Math.ceil((((Number(matchSzafa[0].attributes.wysokosc) * 3) - otw) / 3) - 1)
      this.changeValueOutputs('szafa_wolne_miejsce', 'value', wolneMiejsceOtw)
    },
    search_akumulator (wartosc, depth) {
      // console.log(wartosc, depth)
      var matchBatteries = []
      // var matchBatteries600 = []
      // var matchBatteries800 = []
      this.ListaAkumulatory.filter(item => {
        if (item.pojemnosc >= wartosc) { // && item.glebokosc.indexOf(depth) > -1) {
          item.label = item.kod + ', ' + (Number(item.ilosc) / 2) + 'x ciąg, poj: ' + item.pojemnosc + 'Ah'
          matchBatteries.push(item)
        }
      })

      // this.ListaAkumulatory['600'].filter(item => {
      //   if (item.pojemnosc >= wartosc) {
      //     item.label = item.kod + ', ' + (Number(item.ilosc) / 2) + 'x ciąg, poj: ' + item.pojemnosc + 'Ah'
      //     matchBatteries600.push(item)
      //   }
      // })
      // this.ListaAkumulatory['800'].filter(item => {
      //   if (item.pojemnosc >= wartosc) {
      //     item.label = item.kod + ', ' + (Number(item.ilosc) / 2) + 'x ciąg, poj: ' + item.pojemnosc + 'Ah'
      //     matchBatteries800.push(item)
      //   }
      // })
      // matchBatteries = {'600': matchBatteries600, '800': matchBatteries800}
      return matchBatteries
    },
    search_akumulator_depth (wartosc, depth) {
      // console.log(wartosc, depth)
      var matchBatteries = []
      // var matchBatteries600 = []
      // var matchBatteries800 = []
      this.ListaAkumulatory.filter(item => {
        if (item.pojemnosc >= wartosc && item.glebokosc.indexOf(depth) > -1) {
          item.label = item.kod + ', ' + (Number(item.ilosc) / 2) + 'x ciąg, poj: ' + item.pojemnosc + 'Ah'
          matchBatteries.push(item)
        }
      })
      return matchBatteries
    },
    search_zasilacz (moc, iloscWzmacniaczy, iloscAkumulatorow) {
      var liczbaWejsc = (iloscWzmacniaczy > 5) ? 9 : 5
      var liczbaCiagu = iloscAkumulatorow / 2
      var matchPowerSupply = []
      // eslint-disable-next-line
      matchPowerSupply = this.ListaZasilacze.filter(item => (item.attributes.moc >= moc && item.attributes.ciag == liczbaCiagu && item.attributes.wyjscia == liczbaWejsc))
      return matchPowerSupply
    },
    search_listwyD (faza) {
      var matchStrip = []
      // eslint-disable-next-line
      matchStrip = this.ListaListwyD.filter(item => (item.attributes.faza == faza))
      return matchStrip
    },
    search_listwyZ (ciag, faza) {
      var matchStrip = []
      // eslint-disable-next-line
      matchStrip = this.ListaListwyZ.filter(item => (item.attributes.ciag == ciag && item.attributes.faza == faza))
      return matchStrip
    },
    selected_akumulator (aBattries, glebokosc) {
      this.changeValueOutputs('akumulator', 'array', aBattries[0])
      // if (glebokosc === 600 || glebokosc === '600') {
      //   if (aBattries['600'].length > 0) {
      //     this.changeValueOutputs('akumulator', 'array', aBattries['600'][0])
      //     return aBattries['600'][0]
      //   } else {
      //     alert('INFORMACJA\nBRAK AKUMULATORÓW DLA ZADANEJ SZAFY')
      //     return []
      //   }
      // } else if (glebokosc === 800 || glebokosc === '800') {
      //   if (aBattries['800'].length > 0) {
      //     this.changeValueOutputs('akumulator', 'array', aBattries['800'][0])
      //     return aBattries['800'][0]
      //   } else {
      //     return []
      //   }
      // } else {
      //   return []
      // }
    },
    // ================================================
    pobor_pradu_3fazy (iloscWzmacniaczy, pobor) {
      var maxPoborPradu = 0
      var poborPraduWzmacniacza = 3.82 // 3.25
      var poborPraduZasilacza = Number(pobor) // 230;

      switch (iloscWzmacniaczy) {
        case 1: maxPoborPradu = this.podaj_wieksza_wartosc(poborPraduWzmacniacza, poborPraduZasilacza); break
        case 2: maxPoborPradu = this.podaj_wieksza_wartosc(poborPraduWzmacniacza, poborPraduZasilacza); break
        case 3: maxPoborPradu = this.podaj_wieksza_wartosc(poborPraduWzmacniacza, (poborPraduWzmacniacza + poborPraduZasilacza)); break
        case 4: maxPoborPradu = this.podaj_wieksza_wartosc((2 * poborPraduWzmacniacza), (poborPraduWzmacniacza + poborPraduZasilacza)); break
        case 5: maxPoborPradu = this.podaj_wieksza_wartosc((2 * poborPraduWzmacniacza), (poborPraduWzmacniacza + poborPraduZasilacza)); break
        case 6: maxPoborPradu = this.podaj_wieksza_wartosc((2 * poborPraduWzmacniacza), ((2 * poborPraduWzmacniacza) + poborPraduZasilacza)); break
        case 7: maxPoborPradu = this.podaj_wieksza_wartosc((2 * poborPraduWzmacniacza), ((2 * poborPraduWzmacniacza) + poborPraduZasilacza)); break
        case 8: maxPoborPradu = this.podaj_wieksza_wartosc((3 * poborPraduWzmacniacza), ((2 * poborPraduWzmacniacza) + poborPraduZasilacza)); break
        case 9: maxPoborPradu = this.podaj_wieksza_wartosc((3 * poborPraduWzmacniacza), ((3 * poborPraduWzmacniacza) + poborPraduZasilacza)); break
        default: break
      }
      return maxPoborPradu
    },
    podaj_wieksza_wartosc (war1, war2) {
      if (war1 >= war2) {
        return war1
      } else {
        return war2
      }
    },
    bezpiecznik (wartoscPradu) {
      var wartoscBezpiecznika = 0
      wartoscBezpiecznika = Object.values(this.config.zabezpieczenie.value).filter(element => wartoscPradu < element)
      return wartoscBezpiecznika[0]
    },
    wielkosc_szafy_rack (wysokoscPoprzednia, pola) {
      // console.log('wysokoscPoprzednia: ', wysokoscPoprzednia)

      var maxHigher = 50 // 50 - najwyższa szafa
      var maxHigherHoles = 3 * maxHigher
      var wysokoscSzafyU = 0
      var wolneMiejsceOtw = 0

      if (((maxHigherHoles - pola) / 3) < 0) {
        alert('INFORMACJA\nBrak szafy dla zadanych elementów!')
        this.changeValueInputs(this.selected_input, 'value', (this.inputs[this.selected_input].value - 1))
        this.obliczenia_sprzetu()
      } else {
        wysokoscSzafyU = (pola / 3) - 0.1
        var matchRACK = this.search_szafy(wysokoscSzafyU)
        this.changeValueOutputs('szafa', 'array', matchRACK[0])

        this.$store.commit('app/SET_DIALOG_INFO', {'active': false, 'text': ''})
        this.check_depth_rack(matchRACK[0].attributes.wysokosc, matchRACK)
        wolneMiejsceOtw = Math.ceil(((Number(this.outputs.szafa.attributes.wysokosc) * 3) - pola) / 3) - 1
        this.changeValueOutputs('szafa_wolne_miejsce', 'value', wolneMiejsceOtw)
      }

      // wysokoscSzafyU = (pola / 3) - 0.1
      // var matchRACK = this.search_szafy(wysokoscSzafyU)

      // if (((maxHigherHoles - pola) / 3) < 0) {
      //   alert('INFORMACJA\nBrak szafy dla zadanych elementów!')
      //   this.changeValueInputs(this.selected_input, 'value', (this.inputs[this.selected_input].value - 1))
      //   this.obliczenia_sprzetu()
      // } else {
      //   if ((wysokoscPoprzednia - pola) > -1) {
      //     wolneMiejsceOtw = Math.ceil((wysokoscPoprzednia - pola) / 3) - 1
      //     this.changeValueOutputs('szafa_wolne_miejsce', 'value', wolneMiejsceOtw)
      //   } else {
      //     this.$store.commit('app/SET_DIALOG_INFO', {'active': false, 'text': ''})
      //     this.check_depth_rack(matchRACK[0].attributes.wysokosc, matchRACK)
      //     this.changeValueOutputs('szafa', 'array', matchRACK[0])
      //     // wolneMiejsceOtw = Math.ceil(((Number(this.outputs.szafa.attributes.wysokosc) * 3) - pola) / 3) - 1
      //     // console.log(this.outputs.szafa.attributes.wysokosc)
      //     // console.log((this.outputs.szafa.attributes.wysokosc * 3))
      //     // console.log(pola)
      //     // this.changeValueOutputs('szafa_wolne_miejsce', 'value', wolneMiejsceOtw)
      //     this.obliczenia_sprzetu()
      //   }
      // }
      /*

      if (((maxHigherHoles - pola) / 3) < 0) {
        // wysokoscSzafyU = maxHigher
        // console.log('elementy wychodzą poza zakres szafy')
        // this.$store.commit('app/SET_DIALOG_INFO', {'active': true, 'text': 'Brak szafy dla zadanych elementów!'})
        alert('INFORMACJA\nBrak szafy dla zadanych elementów!')

        this.changeValueInputs(this.selected_input, 'value', (this.inputs[this.selected_input].value - 1))
        this.obliczenia_sprzetu()
      } else {
        wysokoscSzafyU = (pola / 3) - 0.1
        var matchRACK = this.search_szafy(wysokoscSzafyU)
        var wysokoscPotrzebna = matchRACK[0].attributes.wysokosc
        var nowaSzafa = matchRACK.filter(item => (item.attributes.wysokosc === wysokoscPotrzebna && item.attributes.glebokosc === this.inputs.glebokosc_szafy.value))

        if (nowaSzafa.length > 0) {
          this.changeValueOutputs('szafa', 'array', nowaSzafa[0])
        } else {
          this.changeValueOutputs('szafa', 'array', matchRACK[0])
        }
        var oldDepth = this.inputs.glebokosc_szafy.value

        this.$store.commit('app/SET_DIALOG_INFO', {'active': false, 'text': ''})
        this.check_depth_rack(matchRACK[0].attributes.wysokosc, matchRACK)

        if (oldDepth !== this.inputs.glebokosc_szafy.value) {
          // this.obliczenia_sprzetu()
        }
        var wolneMiejsceOtw = Math.ceil((((Number(matchRACK[0].attributes.wysokosc) * 3) - pola) / 3) - 1)
        // console.log('wolneMiejsceOtw: ', wolneMiejsceOtw)
        if (wolneMiejsceOtw < 0) {
          wolneMiejsceOtw = 0
        }
        // this.changeValueOutputs('szafa_wolne_miejsce', 'value', wolneMiejsceOtw)

        if (Number(wysokoscPoprzednia) !== Number(this.outputs.szafa.attributes.wysokosc)) {
          this.obliczenia_sprzetu()
        }
      }
      */
    },
    zmien_szafe_po_glebokosci (wielkosc, glebokosc) {
      var nowaSzafa = this.ListaSzafy.filter(item => (item.attributes.wysokosc === wielkosc.toString() && item.attributes.glebokosc === glebokosc))
      if (nowaSzafa.length > 0) {
        this.changeValueOutputs('szafa', 'array', nowaSzafa[0])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/calculation.js